import { useMapContext } from 'widgets/earthMap/contexts/mapContext';
import { useEffect } from 'react';

export default function useHoverOpacity({ layerName, sourceName }) {
	const [{ map, hoveredFeature }] = useMapContext();

	useEffect(() => {
		if (!map) return;
		const source = map.getSource(sourceName);
		if (!source) return;
		const layer = map.getLayer(layerName);
		if (!layer) return;
		map.setPaintProperty(layerName, 'circle-opacity', ['match', ['id'], hoveredFeature?.id ?? -1, 1, 0]);
		map.setPaintProperty(layerName, 'circle-stroke-opacity', ['match', ['id'], hoveredFeature?.id ?? -1, 1, 0]);
	}, [map, hoveredFeature, layerName, sourceName]);
}
